module.exports = __webpack_public_path__ + "img/bd29dd8.png";